import {ChangeDetectionStrategy, Component, inject, OnInit, signal} from '@angular/core';
import {AsyncPipe, DatePipe} from "@angular/common";
import {MessageService, PrimeTemplate} from "primeng/api";
import {TableModule} from "primeng/table";
import {ApplicationService} from "../../services/application.service";
import {TypedTableRowDirective} from "../../typed-table-row.directive";
import {RouterLink} from "@angular/router";
import {Button} from "primeng/button";
import {finalize} from "rxjs";

@Component({
  selector: 'app-applications-tab',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    AsyncPipe,
    TypedTableRowDirective,
    RouterLink,
    Button
  ],
  templateUrl: './applications-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationsTabComponent implements OnInit {
  private readonly applicationService = inject(ApplicationService);
  private readonly messageService = inject(MessageService);
  protected readonly applications$ = this.applicationService.failedApplications$;
  protected readonly isRetryingFailedApplications = signal(false);

  ngOnInit() {
    this.applicationService.retrieveApplications().subscribe();
  }

  protected retryFailedApplications() {
    if (this.isRetryingFailedApplications()) {
      return;
    }

    this.isRetryingFailedApplications.set(true);

    this.applicationService.retryAllFailedApplications().pipe(
      finalize(() => this.isRetryingFailedApplications.set(false))
    ).subscribe({
      next: response => {
        this.messageService.add({
          severity: 'success',
          summary: 'Retry started',
          detail: `Queued retry for ${response.retried} failed ${response.retried === 1 ? 'application' : 'applications'}.`
        });

        this.applicationService.retrieveApplications().subscribe();
      },
      error: error => {
        console.error('Failed to retry failed applications', error);
        const detail = error instanceof Error ? error.message : 'Failed to retry failed lotteries.';
        this.messageService.add({
          severity: 'error',
          summary: 'Retry failed',
          detail
        });
      }
    });
  }
}
